import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from 'src/shared/shared.module';
import { NewTouMainPage } from './new-tou-main';
import { MeKoPage } from './new-plan/me-ko/me-ko';
import { PlanKoPage } from './new-plan/plan-ko/plan-ko';
import { PlanOnePage } from './new-plan/plan-one/plan-one';
import { PreRoundPage } from './new-plan/pre-round/pre-round';
import { PreRoundKoPage } from './new-plan/pre-round-ko/pre-round-ko';
import { TwoGruppeKoPage } from './new-plan/two-group-ko/two-group-ko';
import { TwoGKoPlPage } from './new-plan/twog-ko-pl/twog-ko-pl';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';


const routes: Routes = [
  { path: '', component: NewTouMainPage },
  { path: 'me-ko', component: MeKoPage },
  { path: 'plan-ko', component: PlanKoPage },
  { path: 'plan-one', component: PlanOnePage },
  { path: 'pre-round', component: PreRoundPage},
  { path: 'pre-round-ko', component: PreRoundKoPage },
  { path: 'two-group-ko', component: TwoGruppeKoPage },
  { path: 'twog-ko-pl', component: TwoGKoPlPage}

];

@NgModule({
  declarations: [
    NewTouMainPage,
    MeKoPage,
    PlanKoPage,
    PlanOnePage,
    PreRoundPage,
    PreRoundKoPage,
    TwoGruppeKoPage,
    TwoGKoPlPage
  ],
  imports: [
    CommonModule,
    SharedModule,
    IonicModule,
    FormsModule,
    HttpClientModule,
    TranslateModule,
    RouterModule.forChild(routes)
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [
  ]
})
export class GamerNewModule {}
